(function(root){
  function prices(variant, productId, config){
    var original=Number(variant.price), sale=original, compare=Number(variant.compare_at_price)||0;
    if(config && config.enabled && config.productIds.includes(String(productId)) && !variant.compare_at_price){sale=Math.round(original*0.5);compare=original;}
    return {price:sale,compare:compare,percent:compare>sale?Math.round((compare-sale)*100/compare):0};
  }
  root.EPSalePricing={prices:prices};
  if(typeof module!=='undefined')module.exports=root.EPSalePricing;
})(typeof window==='undefined'?globalThis:window);
